import React, { useCallback, useEffect, useState } from 'react'
import { getService } from '../../parameters'
import SERVICES from '../../services.constants'
import request from '../utils/request'
import { ONE_SECOND_MS, ONE_WEEK_MS } from '../utils/date'
import { isPE, withOnlyBrowser } from '../Device'
import s from './AskForUpdate.less'
import useEventCallback from '../utils/useEventCallback'
import { useSelector } from 'react-redux'
import { selectHeaderHeight } from '../../store/ui/ui.selectors'
import { HEADER_SUBHEADER_HEIGHT } from '../header/header-constants'
import { selectLocale } from '../../store/locale/locale.selectors'
import { translate } from '../i18n/T'
import debug from 'debug'

const d = debug('update')

const TEST_MODE = location.hash === '#test-update'

const DELAY_BETWEEN_CHECKS = TEST_MODE ? 10 * ONE_SECOND_MS : 2 * ONE_WEEK_MS // ONE_MONTH_MS cause setInterval to be called in loop

if (d.enabled) {
  d('delay between checks', DELAY_BETWEEN_CHECKS)
}

export const fetchVersion = () => {
  const serviceUrl = getService(SERVICES.WEB_VERSION)
  return request
    .get(serviceUrl, { silent: true })
    .then(({ data }) => data)
    .catch(e => console.warn('error while fetching version', e))
}

// webpack:BrowserOnly
const AskForUpdate = () => {
  const [version, setVersion] = useState(global.__APP_VERSION__)
  const isSameVersion = global.__APP_VERSION__ === version
  const locale = useSelector(selectLocale)
  const t = translate(locale)

  if (d.enabled) {
    d('version:', version, 'isSameVersion:', isSameVersion)
  }

  const headerHeight = useSelector(selectHeaderHeight)
  const height = isPE() ? headerHeight + HEADER_SUBHEADER_HEIGHT + 30 : 80

  const loadVersion = useCallback(async () => {
    const newVersion = await fetchVersion()
    if (d.enabled) {
      d('loadVersion, got:', newVersion, 'vs:', version)
    }
    if (newVersion) {
      setVersion(TEST_MODE ? 'v+' : newVersion)
    }
  }, [setVersion])

  useEffect(() => {
    if (!isSameVersion) return
    const intervalId = setInterval(() => {
      loadVersion()
    }, DELAY_BETWEEN_CHECKS)
    return () => clearInterval(intervalId)
  }, [isSameVersion, loadVersion])

  const reload = useEventCallback(() => location.reload(), [])

  if (isSameVersion) return <></>

  return (
    <div className={s.root} style={{ top: `${height}px` }}>
      {t('update.msg')}
      <a href="/" className={s.refresh} onClick={reload}>
        {t('update.refresh')}
      </a>
    </div>
  )
}

export default withOnlyBrowser(AskForUpdate)
